class ProductCertificateCard extends HTMLElement {
  connectedCallback() {
    const toggle = this.querySelector('[data-ph-toggle]');
    if (toggle) toggle.addEventListener('click', this.handleToggle.bind(this));
  }

  handleToggle(e) {
    const btn = e.currentTarget;
    const preview = this.querySelector('[data-ph-preview]');
    if (!preview) return;
    const isHidden = preview.hasAttribute('hidden');
    if (isHidden) {
      preview.removeAttribute('hidden');
      btn.textContent = btn.dataset.hideLabel;
    } else {
      preview.setAttribute('hidden', '');
      btn.textContent = btn.dataset.showLabel;
    }
  }
}

customElements.define('product-certificate-card', ProductCertificateCard);